import React from 'react';
import { Damage } from '@/types';
import { Tag } from 'antd';

type ActionType = 'FR' | 'Labour';

const normalizeValue = (value?: string) => (value || '').trim().toLowerCase();

export const getDamageLineOptions = (
  damageLines: Damage[] = [],
  code?: string,
  actionType: ActionType = 'FR',
) => {
  const normalizedCode = normalizeValue(code);

  return damageLines.map((o) => {
    const isUsed =
      normalizedCode.length > 0 &&
      o.actions.some((action) =>
        actionType === 'FR'
          ? normalizeValue(action.flatRateCode) === normalizedCode
          : normalizeValue(action.labourType) === normalizedCode,
      );

    const damageLineLabel = `${o.damageAreaDesc} - ${o.damagePartDesc} - ${o.repairActionDesc}`;

    return {
      label: isUsed ? (
        <>
          <Tag color="orange" className="me-2">
            Exists
          </Tag>
          {damageLineLabel}
        </>
      ) : (
        damageLineLabel
      ),
      value: o.id,
    };
  });
};
